import i18n from '@/plugins/i18n';
import { ConfigType } from '@/components/Common/graph.types';

export const getForcastChartConfig = ({
  title,
  width = '40%',
  entityType,
  metricName,
  axisLabelsY,
  header,
  aggregation
}: ConfigType) => {
  return {
    title: title,
    queryName: 'queryGetAIMetricValues',
    graphType: 'forecast',
    type: 'rangeArea',
    width: width,
    metricName: metricName,
    entityType: entityType,
    header: {
      titlePrefixIcon: header.titlePrefixIcon,
      titleSuffixIcon: header.titleSuffixIcon || 'starFilled',
      displayOnlyUnit: header.displayOnlyUnit,
      unit: header.unit,
      isError: header.isError,
      showAnomaly: true,
    },
    isForecast: true,
    axisLabels: {
      x: i18n.global.t('time'),
      y: axisLabelsY,
    },
    aggregation: aggregation
  };
};
